module.exports = __webpack_public_path__ + "img/mood2.5afc528d.png";